module.exports = __webpack_public_path__ + "img/review-code.02622ce0.png";